import React from "react";
import PropTypes from "prop-types";
import generateXLSX from "../../utils/spreadsheets";
import { tranStr } from "../../utils/translation";

import { columns } from "../benchmarking-project/BenchmarkingTable.functions";

ExportBenchmarkDashboard.propTypes = {
  benchmarks: PropTypes.array,
  user: PropTypes.object,
};

// API
export default function ExportBenchmarkDashboard(props) {
  const { benchmarks } = props;

  const benchmarkColumns = columns();

  const headings = benchmarkColumns.map((header) => header.heading);
  const keys = benchmarkColumns.map((header) => header.key);
  const data = [];

  benchmarks.forEach((bm) => {
    data.push(keys.map((key) => bm[key]));
  });

  data.unshift(headings);

  return (
    <div className="general-row-container">
      <input
        type="button"
        className="general-modal-button benchmark-modal-button"
        value={tranStr("Export All")}
        onClick={() => {
          generateXLSX(tranStr("Benchmark Projects Details"), data);
        }}
        title="Exports all Benchmarks"
      />
    </div>
  );
}
